import React from 'react';
import { Outlet } from 'react-router-dom';


const MentorLayout: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      layout
      <div className="container mx-auto px-4 py-8">
        <Outlet />
      </div>
    </div>
  );
};

export default MentorLayout;
